/* eslint-disable ember/classic-decorator-hooks */
import Controller from '@ember/controller';
import { service } from '@ember/service';
import { tracked } from '@glimmer/tracking';
import { isMobile } from '@linc-technologies/linced-common/utils/platform';

export default class IndexController extends Controller {
  @service
  session;

  @tracked
  isMobile;

  init() {
    super.init(...arguments);
    this.isMobile = isMobile();
  }
}
